import type React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@xing-com/button';
import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';
import { SuperEllipse } from '@xing-com/super-ellipse';
import { Meta } from '@xing-com/typography';

import type { PeopleProfileItemFields } from '../types';
import {
  StyledContainer,
  StyledContent,
  StyledUserData,
  StyledHeadline,
  StyledBodyCopy,
} from './people-profile-page-link.styles';

export const PeopleProfilePageLink: React.FC<PeopleProfileItemFields> = ({
  name,
  photoUrl,
  occupationTitle,
  city,
  url,
}) => {
  const { formatMessage } = useIntl();
  const scaledPhotoUrl = `${photoUrl}.128x128.jpg`;

  return (
    <StyledContainer href={sanitizeUrl(url)}>
      <StyledContent>
        <SuperEllipse
          src={scaledPhotoUrl}
          profileName={name}
          size="large"
          sizeConfined="medium"
        />
        <StyledUserData>
          <StyledHeadline size="large">{name}</StyledHeadline>
          <StyledBodyCopy size="medium">{occupationTitle}</StyledBodyCopy>
          <Meta size="small" noMargin>
            {city}
          </Meta>
        </StyledUserData>
      </StyledContent>
      <Button variant="secondary" size="small">
        {formatMessage({ id: 'PD_CARD_BUTTON' })}
      </Button>
    </StyledContainer>
  );
};
